import React from 'react'
import { createRoot } from 'react-dom/client'
import '@caudena/core/styles'
import { RootRouterProvider } from '@caudena/core/App'

import routes from './routes'

const container = document.getElementById('root')
if (!container) throw new Error('Root element not found')
const rootContainer = createRoot(container)

rootContainer.render(<RootRouterProvider routes={routes} />)
